import { ShareFeedbackAttribute } from "../type";

export const findExistingAttribute = (
  shareData: Array<ShareFeedbackAttribute>,
  attributeId: number
): ShareFeedbackAttribute | undefined =>
  shareData.find((item) => item.attributeId === attributeId);
